/* eslint-disable no-undef */
const colorTheme = {
  // Dark/Light 모드 1:1 대응되는 색상
  'Element Color': [
    {
      name: 'EL_10',
      tw: 'el-10',
      color: 'rgb(var(--element-el-10))',
      theme: 'theme.colors[el-10]',
    },
    {
      name: 'EL_15',
      tw: 'el-15',
      color: 'rgb(var(--element-el-15))',
      theme: 'theme.colors[el-15]',
    },
    {
      name: 'EL_20',
      tw: 'el-20',
      color: 'rgb(var(--element-el-20))',
      theme: 'theme.colors[el-20]',
    },
    {
      name: 'EL_30',
      tw: 'el-30',
      color: 'rgb(var(--element-el-30))',
      theme: 'theme.colors[el-30]',
    },
    {
      name: 'EL_35',
      tw: 'el-35',
      color: 'rgb(var(--element-el-35))',
      theme: 'theme.colors[el-35]',
    },
    {
      name: 'EL_40',
      tw: 'el-40',
      color: 'rgb(var(--element-el-40))',
      theme: 'theme.colors[el-40]',
    },
    {
      name: 'EL_50',
      tw: 'el-50',
      color: 'rgb(var(--element-el-50))',
      theme: 'theme.colors[el-50]',
    },
    {
      name: 'EL_60',
      tw: 'el-60',
      color: 'rgb(var(--element-el-60))',
      theme: 'theme.colors[el-60]',
    },
    {
      name: 'EL_70',
      tw: 'el-70',
      color: 'rgb(var(--element-el-70))',
      theme: 'theme.colors[el-70]',
    },
    {
      name: 'EL_BC',
      tw: 'el-bc',
      color: 'rgb(var(--element-el-bc))',
      theme: 'theme.colors[el-bc]',
    },
  ],
  // 다크/라이트 모드 동일하게 사용되는 단일색
  'Static Color': [
    {
      name: 'S_Black',
      tw: 's-black',
      color: 'rgb(var(--static-black))',
      theme: 'theme.colors[s-black]',
    },
    {
      name: 'S_White',
      tw: 's-white',
      color: 'rgb(var(--static-white))',
      theme: 'theme.colors[s-white]',
    },
    {
      name: 'S_Gray_10',
      tw: 's-gray-10',
      color: 'rgb(var(--static-gray-10))',
      theme: 'theme.colors[s-gray-10]',
    },
    {
      name: 'S_Gray_20',
      tw: 's-gray-20',
      color: 'rgb(var(--static-gray-20))',
      theme: 'theme.colors[s-gray-20]',
    },
    {
      name: 'S_Gray_30',
      tw: 's-gray-30',
      color: 'rgb(var(--static-gray-30))',
      theme: 'theme.colors[s-gray-30]',
    },
    {
      name: 'S_Yellow',
      tw: 's-yellow',
      color: 'rgb(var(--static-yellow))',
      theme: 'theme.colors[s-yellow]',
    },
    {
      name: 'S_Yellow_NEW',
      tw: 's-yellow-new',
      color: 'rgb(var(--static-yellow-new))',
      theme: 'theme.colors[s-yellow-new]',
    },
    {
      name: 'S_Red',
      tw: 's-red',
      color: 'rgb(var(--static-red))',
      theme: 'theme.colors[s-red]',
    },
    {
      name: 'S_Green',
      tw: 's-green',
      color: 'rgb(var(--static-green))',
      theme: 'theme.colors[s-green]',
    },
    {
      name: 'S_Blue',
      tw: 's-blue',
      color: 'rgb(var(--static-blue))',
      theme: 'theme.colors[s-blue]',
    },
    {
      name: 'S_Violet',
      tw: 's-violet',
      color: 'rgb(var(--static-violet))',
      theme: 'theme.colors[s-violet]',
    },
    {
      name: 'S_Mint',
      tw: 's-mint',
      color: 'rgb(var(--static-mint))',
      theme: 'theme.colors[s-mint]',
    },
    {
      name: 'S_Helixkey',
      tw: 's-helixkey',
      color: 'rgb(var(--static-helixkey))',
      theme: 'theme.colors[s-helixkey]',
    },
  ],
  // 배경에 쓰이는 컬러. 다크/라이트모드 대응되는 컬러이다.
  'BG Pairing Color': [
    {
      name: 'BG_A_10',
      tw: 'bg-a-10',
      color: 'rgb(var(--bg-a-10))',
      theme: 'theme.colors[bg-a-10]',
    },
    {
      name: 'BG_A_20',
      tw: 'bg-a-20',
      color: 'rgb(var(--bg-a-20))',
      theme: 'theme.colors[bg-a-20]',
    },
    {
      name: 'BG_B_10',
      tw: 'bg-b-10',
      color: 'rgb(var(--bg-b-10))',
      theme: 'theme.colors[bg-b-10]',
    },
    {
      name: 'BG_B_20',
      tw: 'bg-b-20',
      color: 'rgb(var(--bg-b-20))',
      theme: 'theme.colors[bg-b-20]',
    },
    {
      name: 'BG_20',
      tw: 'bg-20',
      color: 'rgb(var(--bg-20))',
      theme: 'theme.colors[bg-20]',
    },
  ],
  // Divider, Border 등에 쓰이는 라인 색상. 다크/라이트모드 대응되는 컬러.
  'Line Color': [
    {
      name: 'line_10',
      tw: 'line-10',
      color: 'var(--line-10)',
      theme: 'theme.colors[line-10]',
    },
    {
      name: 'line_20',
      tw: 'line-20',
      color: 'var(--line-20)',
      theme: 'theme.colors[line-20]',
    },
    {
      name: 'line_30',
      tw: 'line-30',
      color: 'var(--line-30)',
      theme: 'theme.colors[line-30]',
    },
  ],
  'Button Color': [
    {
      name: 'BTN_10',
      tw: 'btn-10',
      color: 'rgb(var(--btn-10))',
      theme: 'theme.colors[btn-10]',
    },
    {
      name: 'BTN_20',
      tw: 'btn-20',
      color: 'rgb(var(--btn-20))',
      theme: 'theme.colors[btn-20]',
    },
  ],
  // 위 모든 상황에 해당하지 않는 예외상황에 쓰이는 색상으로 다크/라이트모드 대응되는 컬러.
  'Special Color': [
    {
      name: 'SP_DA_BG',
      tw: 'sp-da-bg',
      color: '#f3f3f3',
      theme: 'theme.colors[sp-da-bg]',
    },
    {
      name: 'SP_Badge_80',
      tw: 'sp-badge-80',
      color: 'rgba(0, 0, 0, 0.8)',
      theme: 'theme.colors[sp-badge-80]',
    },
    {
      name: 'SP_Dimmed',
      tw: 'sp-dimmed',
      color: 'rgba(0, 0, 0, 0.7)',
      theme: 'theme.colors[sp-dimmed]',
    },
    {
      name: 'SP_Thumb_line',
      tw: 'sp-thumb-line',
      color: 'var(--sp-thumb-line)',
      theme: 'theme.colors[sp-thumb-line]',
    },
    {
      name: 'SP_Btnbase',
      tw: 'sp-btnbase',
      color: 'rgb(var(--sp-btnbase))',
      theme: 'theme.colors[sp-btnbase]',
    },
    {
      name: 'SP_BtnWuf',
      tw: 'sp-btnwuf',
      color: 'rgb(var(--sp-btnwuf))',
      theme: 'theme.colors[sp-btnwuf]',
    },
    {
      name: 'SP_Skeleton',
      tw: 'sp-skeleton',
      color: 'var(--sp-skeleton)',
      theme: 'theme.colors[sp-skeleton]',
    },
    {
      name: 'SP_BG_blur',
      tw: 'sp-bg-blur',
      color: 'var(--sp-bg-blur)',
      theme: 'theme.colors[sp-bg-blur]',
    },
    {
      name: 'SP_BG_first',
      tw: 'sp-bg-first',
      color: 'var(--sp-bg-first)',
      theme: 'theme.colors[sp-bg-first]',
    },
    {
      name: 'SP_BG_card',
      tw: 'sp-bg-card',
      color: 'rgb(var(--sp-bg-card))',
      theme: 'theme.colors[sp-bg-card]',
    },
    {
      name: 'SP_BG_popup',
      tw: 'sp-bg-popup',
      color: 'rgb(var(--sp-bg-popup))',
      theme: 'theme.colors[sp-bg-popup]',
    },
  ],
  // 뷰어에서 사용되는 전용 컬러.
  'Viewer Color': [
    {
      name: 'Epub_white_bg',
      tw: 'epub-white-bg',
      color: '#ffffff',
      theme: 'theme.colors[epub-white-bg]',
    },
    {
      name: 'Epub_white_text',
      tw: 'epub-white-text',
      color: '#222222',
      theme: 'theme.colors[epub-white-text]',
    },
    {
      name: 'Epub_lightgray_bg',
      tw: 'epub-lightgray-bg',
      color: '#e0e0e0',
      theme: 'theme.colors[epub-lightgray-bg]',
    },
    {
      name: 'Epub_lightgray_text',
      tw: 'epub-lightgray-text',
      color: '#222222',
      theme: 'theme.colors[epub-lightgray-text]',
    },
    {
      name: 'Epub_darkgray_bg',
      tw: 'epub-darkgray-bg',
      color: '#222222',
      theme: 'theme.colors[epub-darkgray-bg]',
    },
    {
      name: 'Epub_darkgray_text',
      tw: 'epub-darkgray-text',
      color: '#bcbcbc',
      theme: 'theme.colors[epub-darkgray-text]',
    },
    {
      name: 'Epub_black_bg',
      tw: 'epub-black-bg',
      color: '#000000',
      theme: 'theme.colors[epub-black-bg]',
    },
    {
      name: 'Epub_black_text',
      tw: 'epub-black-text',
      color: '#eeeeee',
      theme: 'theme.colors[epub-black-text]',
    },
    {
      name: 'Epub_sepia_bg',
      tw: 'epub-sepia-bg',
      color: '#f6f1e5',
      theme: 'theme.colors[epub-sepia-bg]',
    },
    {
      name: 'Epub_sepia_text',
      tw: 'epub-sepia-text',
      color: '#4e3726',
      theme: 'theme.colors[epub-sepia-text]',
    },
    {
      name: 'Epub_green_bg',
      tw: 'epub-green-bg',
      color: '#233e3b',
      theme: 'theme.colors[epub-green-bg]',
    },
    {
      name: 'Epub_green_text',
      tw: 'epub-green-text',
      color: '#c8d9d7',
      theme: 'theme.colors[epub-green-text]',
    },
    {
      name: 'Viewer_audio_mini',
      tw: 'viewer-audio-mini',
      color: 'rgba(255, 255, 255, 0.3)',
      theme: 'theme.colors[epub-green-text]',
    },
    {
      name: 'Viewer_end',
      tw: 'viewer-end',
      color: 'rgba(0, 0, 0, 0.8)',
      theme: 'theme.colors[viewer-end]',
    },
    {
      name: 'Viewer_tutorial',
      tw: 'viewer-tutorial',
      color: 'rgba(0, 0, 0, 0.85)',
      theme: 'theme.colors[viewer-tutorial]',
    },
    {
      name: 'Viewer_auto',
      tw: 'viewer-auto',
      color: 'var(--viewer-auto)',
      theme: 'theme.colors[viewer-auto]',
    },
    {
      name: 'Epub_hyperlink',
      tw: 'epub-hyperlink',
      color: 'rgb(var(--epub-hyperlink))',
      theme: 'theme.colors[epub-hyperlink]',
    },
  ],
  // 이는 디자인가이드로 관리되는 색상은 아닙니다. 디자인팀에서 gradient 등을 표현할 때 사용하는 색상을 집합시켜 놓았습니다. ({Hexcode}-{opacity*100} 혹은 {컬러 테마명}-{opacity*100})
  'Custom Color': [
    {
      name: 'EL_70_15',
      tw: 'el-70-15',
      color: 'var(--element-el-70-15)',
      theme: 'theme.colors[el-70-15]',
    },
    {
      name: 'EL_20_30',
      tw: 'el-20-30',
      color: 'var(--element-el-20-30)',
      theme: 'theme.colors[el-20-30]',
    },
    {
      name: 'EL_60_30',
      tw: 'el-60-30',
      color: 'var(--element-el-60-30)',
      theme: 'theme.colors[el-60-30]',
    },
    {
      name: 'BG_B_20/0',
      tw: 'bg-b-20/0',
      color: 'var(--bg-b-20-0)',
      theme: 'theme.colors[bg-b-20/0]',
    },
    {
      name: 'BG_A_10/0',
      tw: 'bg-a-10/0',
      color: 'var(--bg-a-10-0)',
      theme: 'theme.colors[bg-a-10/0]',
    },
    {
      name: 'BG_A_10/75',
      tw: 'bg-a-10/75',
      color: 'var(--bg-a-10-75)',
      theme: 'theme.colors[bg-a-10/75]',
    },
  ],
};

const newColorTheme = {
  'Core Grayscale Color': [
    {
      name: 'CORE_GRAYSCALE_GRAY_0',
      tw: 'grayscale-gray-0',
      color: 'rgb(var(--core-grayscale-gray-0))',
      theme: 'theme.colors[grayscale-gray-0]',
    },
    {
      name: 'CORE_GRAYSCALE_GRAY_05',
      tw: 'grayscale-gray-05',
      color: 'rgb(var(--core-grayscale-gray-05))',
      theme: 'theme.colors[grayscale-gray-05]',
    },
    {
      name: 'CORE_GRAYSCALE_GRAY_10',
      tw: 'grayscale-gray-10',
      color: 'rgb(var(--core-grayscale-gray-10))',
      theme: 'theme.colors[grayscale-gray-10]',
    },
    {
      name: 'CORE_GRAYSCALE_GRAY_15',
      tw: 'grayscale-gray-15',
      color: 'rgb(var(--core-grayscale-gray-15))',
      theme: 'theme.colors[grayscale-gray-15]',
    },
    {
      name: 'CORE_GRAYSCALE_GRAY_20',
      tw: 'grayscale-gray-20',
      color: 'rgb(var(--core-grayscale-gray-20))',
      theme: 'theme.colors[grayscale-gray-20]',
    },
    {
      name: 'CORE_GRAYSCALE_GRAY_30',
      tw: 'grayscale-gray-30',
      color: 'rgb(var(--core-grayscale-gray-30))',
      theme: 'theme.colors[grayscale-gray-30]',
    },
    {
      name: 'CORE_GRAYSCALE_GRAY_40',
      tw: 'grayscale-gray-40',
      color: 'rgb(var(--core-grayscale-gray-40))',
      theme: 'theme.colors[grayscale-gray-40]',
    },
    {
      name: 'CORE_GRAYSCALE_GRAY_50',
      tw: 'grayscale-gray-50',
      color: 'rgb(var(--core-grayscale-gray-50))',
      theme: 'theme.colors[grayscale-gray-50]',
    },
    {
      name: 'CORE_GRAYSCALE_GRAY_60',
      tw: 'grayscale-gray-60',
      color: 'rgb(var(--core-grayscale-gray-60))',
      theme: 'theme.colors[grayscale-gray-60]',
    },
    {
      name: 'CORE_GRAYSCALE_GRAY_70',
      tw: 'grayscale-gray-70',
      color: 'rgb(var(--core-grayscale-gray-70))',
      theme: 'theme.colors[grayscale-gray-70]',
    },
    {
      name: 'CORE_GRAYSCALE_GRAY_80',
      tw: 'grayscale-gray-80',
      color: 'rgb(var(--core-grayscale-gray-80))',
      theme: 'theme.colors[grayscale-gray-80]',
    },
    {
      name: 'CORE_GRAYSCALE_GRAY_90',
      tw: 'grayscale-gray-90',
      color: 'rgb(var(--core-grayscale-gray-90))',
      theme: 'theme.colors[grayscale-gray-90]',
    },
    {
      name: 'CORE_GRAYSCALE_GRAY_95',
      tw: 'grayscale-gray-95',
      color: 'rgb(var(--core-grayscale-gray-95))',
      theme: 'theme.colors[grayscale-gray-95]',
    },
    {
      name: 'CORE_GRAYSCALE_GRAY_100',
      tw: 'grayscale-gray-100',
      color: 'rgb(var(--core-grayscale-gray-100))',
      theme: 'theme.colors[grayscale-gray-100]',
    },
  ],
  'Core Hue Color': [
    {
      name: 'CORE_HUE_RED_50',
      tw: 'hue-red-50',
      color: 'rgb(var(--core-hue-red-50))',
      theme: 'theme.colors[hue-red-50]',
    },
    {
      name: 'CORE_HUE_ORANGE_50',
      tw: 'hue-orange-50',
      color: 'rgb(var(--core-hue-orange-50))',
      theme: 'theme.colors[hue-orange-50]',
    },
    {
      name: 'CORE_HUE_YELLOW_50',
      tw: 'hue-yellow-50',
      color: 'rgb(var(--core-hue-yellow-50))',
      theme: 'theme.colors[hue-yellow-50]',
    },
    {
      name: 'CORE_HUE_MINT_50',
      tw: 'hue-mint-50',
      color: 'rgb(var(--core-hue-mint-50))',
      theme: 'theme.colors[hue-mint-50]',
    },
    {
      name: 'CORE_HUE_BLUE_30',
      tw: 'hue-blue-30',
      color: 'rgb(var(--core-hue-blue-30))',
      theme: 'theme.colors[hue-blue-30]',
    },
    {
      name: 'CORE_HUE_BLUE_50',
      tw: 'hue-blue-50',
      color: 'rgb(var(--core-hue-blue-50))',
      theme: 'theme.colors[hue-blue-50]',
    },
    {
      name: 'CORE_HUE_BLUE_60',
      tw: 'hue-blue-60',
      color: 'rgb(var(--core-hue-blue-60))',
      theme: 'theme.colors[hue-blue-60]',
    },
    {
      name: 'CORE_HUE_INDIGO_40',
      tw: 'hue-indigo-40',
      color: 'rgb(var(--core-hue-indigo-40))',
      theme: 'theme.colors[hue-indigo-40]',
    },
    {
      name: 'CORE_HUE_INDIGO_50',
      tw: 'hue-indigo-50',
      color: 'rgb(var(--core-hue-indigo-50))',
      theme: 'theme.colors[hue-indigo-50]',
    },
    {
      name: 'CORE_HUE_VIOLET_50',
      tw: 'hue-violet-50',
      color: 'rgb(var(--core-hue-violet-50))',
      theme: 'theme.colors[hue-violet-50]',
    },
    {
      name: 'CORE_HUE_PURPLE_50',
      tw: 'hue-purple-50',
      color: 'rgb(var(--core-hue-purple-50))',
      theme: 'theme.colors[hue-purple-50]',
    },
    {
      name: 'CORE_HUE_GREEN_10',
      tw: 'hue-green-10',
      color: 'rgb(var(--core-hue-green-10))',
      theme: 'theme.colors[hue-green-10]',
    },
    {
      name: 'CORE_HUE_GREEN_50',
      tw: 'hue-green-50',
      color: 'rgb(var(--core-hue-green-50))',
      theme: 'theme.colors[hue-green-50]',
    },
    {
      name: 'CORE_HUE_GREEN_90',
      tw: 'hue-green-90',
      color: 'rgb(var(--core-hue-green-90))',
      theme: 'theme.colors[hue-green-90]',
    },
    {
      name: 'CORE_HUE_BROWN_10',
      tw: 'hue-brown-10',
      color: 'rgb(var(--core-hue-brown-10))',
      theme: 'theme.colors[hue-brown-10]',
    },
    {
      name: 'CORE_HUE_BROWN_50',
      tw: 'hue-brown-50',
      color: 'rgb(var(--core-hue-brown-50))',
      theme: 'theme.colors[hue-brown-50]',
    },
  ],
  'Core Alpha Color': [
    {
      name: 'CORE_ALPHA_BLACK_A_05',
      tw: 'alpha-black-a-05',
      color: 'var(--core-alpha-black-a-05)',
      theme: 'theme.colors[alpha-black-a-05]',
    },
    {
      name: 'CORE_ALPHA_BLACK_A_10',
      tw: 'alpha-black-a-10',
      color: 'var(--core-alpha-black-a-10)',
      theme: 'theme.colors[alpha-black-a-10]',
    },
    {
      name: 'CORE_ALPHA_BLACK_A_15',
      tw: 'alpha-black-a-15',
      color: 'var(--core-alpha-black-a-15)',
      theme: 'theme.colors[alpha-black-a-15]',
    },
    {
      name: 'CORE_ALPHA_BLACK_A_20',
      tw: 'alpha-black-a-20',
      color: 'var(--core-alpha-black-a-20)',
      theme: 'theme.colors[alpha-black-a-20]',
    },
    {
      name: 'CORE_ALPHA_BLACK_A_25',
      tw: 'alpha-black-a-25',
      color: 'var(--core-alpha-black-a-25)',
      theme: 'theme.colors[alpha-black-a-25]',
    },
    {
      name: 'CORE_ALPHA_BLACK_A_30',
      tw: 'alpha-black-a-30',
      color: 'var(--core-alpha-black-a-30)',
      theme: 'theme.colors[alpha-black-a-30]',
    },
    {
      name: 'CORE_ALPHA_BLACK_A_40',
      tw: 'alpha-black-a-40',
      color: 'var(--core-alpha-black-a-40)',
      theme: 'theme.colors[alpha-black-a-40]',
    },
    {
      name: 'CORE_ALPHA_BLACK_A_50',
      tw: 'alpha-black-a-50',
      color: 'var(--core-alpha-black-a-50)',
      theme: 'theme.colors[alpha-black-a-50]',
    },
    {
      name: 'CORE_ALPHA_BLACK_A_60',
      tw: 'alpha-black-a-60',
      color: 'var(--core-alpha-black-a-60)',
      theme: 'theme.colors[alpha-black-a-60]',
    },
    {
      name: 'CORE_ALPHA_BLACK_A_70',
      tw: 'alpha-black-a-70',
      color: 'var(--core-alpha-black-a-70)',
      theme: 'theme.colors[alpha-black-a-70]',
    },
    {
      name: 'CORE_ALPHA_WHITE_A_05',
      tw: 'alpha-white-a-05',
      color: 'var(--core-alpha-white-a-05)',
      theme: 'theme.colors[alpha-white-a-05]',
    },
    {
      name: 'CORE_ALPHA_WHITE_A_10',
      tw: 'alpha-white-a-10',
      color: 'var(--core-alpha-white-a-10)',
      theme: 'theme.colors[alpha-white-a-10]',
    },
    {
      name: 'CORE_ALPHA_WHITE_A_15',
      tw: 'alpha-white-a-15',
      color: 'var(--core-alpha-white-a-15)',
      theme: 'theme.colors[alpha-white-a-15]',
    },
    {
      name: 'CORE_ALPHA_WHITE_A_20',
      tw: 'alpha-white-a-20',
      color: 'var(--core-alpha-white-a-20)',
      theme: 'theme.colors[alpha-white-a-20]',
    },
    {
      name: 'CORE_ALPHA_WHITE_A_25',
      tw: 'alpha-white-a-25',
      color: 'var(--core-alpha-white-a-25)',
      theme: 'theme.colors[alpha-white-a-25]',
    },
    {
      name: 'CORE_ALPHA_WHITE_A_30',
      tw: 'alpha-white-a-30',
      color: 'var(--core-alpha-white-a-30)',
      theme: 'theme.colors[alpha-white-a-30]',
    },
    {
      name: 'CORE_ALPHA_WHITE_A_40',
      tw: 'alpha-white-a-40',
      color: 'var(--core-alpha-white-a-40)',
      theme: 'theme.colors[alpha-white-a-40]',
    },
    {
      name: 'CORE_ALPHA_WHITE_A_50',
      tw: 'alpha-white-a-50',
      color: 'var(--core-alpha-white-a-50)',
      theme: 'theme.colors[alpha-white-a-50]',
    },
    {
      name: 'CORE_ALPHA_WHITE_A_60',
      tw: 'alpha-white-a-60',
      color: 'var(--core-alpha-white-a-60)',
      theme: 'theme.colors[alpha-white-a-60]',
    },
    {
      name: 'CORE_ALPHA_WHITE_A_70',
      tw: 'alpha-white-a-70',
      color: 'var(--core-alpha-white-a-70)',
      theme: 'theme.colors[alpha-white-a-70]',
    },
    {
      name: 'CORE_ALPHA_SILVER_A_15',
      tw: 'alpha-silver-a-15',
      color: 'var(--core-alpha-silver-a-15)',
      theme: 'theme.colors[alpha-silver-a-15]',
    },
    {
      name: 'CORE_ALPHA_SILVER_A_60',
      tw: 'alpha-silver-a-60',
      color: 'var(--core-alpha-silver-a-60)',
      theme: 'theme.colors[alpha-silver-a-60]',
    },
    {
      name: 'CORE_ALPHA_STONE_A_15',
      tw: 'alpha-stone-a-15',
      color: 'var(--core-alpha-stone-a-15)',
      theme: 'theme.colors[alpha-stone-a-15]',
    },
    {
      name: 'CORE_ALPHA_RED_A_30',
      tw: 'alpha-red-a-30',
      color: 'var(--core-alpha-red-a-30)',
      theme: 'theme.colors[alpha-red-a-30]',
    },
    {
      name: 'CORE_ALPHA_ORANGE_A_30',
      tw: 'alpha-orange-a-30',
      color: 'var(--core-alpha-orange-a-30)',
      theme: 'theme.colors[alpha-orange-a-30]',
    },
    {
      name: 'CORE_ALPHA_BROWN_A_30',
      tw: 'alpha-brown-a-30',
      color: 'var(--core-alpha-brown-a-30)',
      theme: 'theme.colors[alpha-brown-a-30]',
    },
    {
      name: 'CORE_ALPHA_LIME_A_30',
      tw: 'alpha-lime-a-30',
      color: 'var(--core-alpha-lime-a-30)',
      theme: 'theme.colors[alpha-lime-a-30]',
    },
    {
      name: 'CORE_ALPHA_NEON_A_30',
      tw: 'alpha-neon-a-30',
      color: 'var(--core-alpha-neon-a-30)',
      theme: 'theme.colors[alpha-neon-a-30]',
    },
    {
      name: 'CORE_ALPHA_CYAN_A_30',
      tw: 'alpha-cyan-a-30',
      color: 'var(--core-alpha-cyan-a-30)',
      theme: 'theme.colors[alpha-cyan-a-30]',
    },
    {
      name: 'CORE_ALPHA_BLUE_A_30',
      tw: 'alpha-blue-a-30',
      color: 'var(--core-alpha-blue-a-30)',
      theme: 'theme.colors[alpha-blue-a-30]',
    },
    {
      name: 'CORE_ALPHA_LAVENDER_A_30',
      tw: 'alpha-lavender-a-30',
      color: 'var(--core-alpha-lavender-a-30)',
      theme: 'theme.colors[alpha-lavender-a-30]',
    },
    {
      name: 'CORE_ALPHA_MAGENTA_A_30',
      tw: 'alpha-magenta-a-30',
      color: 'var(--core-alpha-magenta-a-30)',
      theme: 'theme.colors[alpha-magenta-a-30]',
    },
    {
      name: 'CORE_ALPHA_YELLOW_A_40',
      tw: 'alpha-yellow-a-40',
      color: 'var(--core-alpha-yellow-a-40)',
      theme: 'theme.colors[alpha-yellow-a-40]',
    },
    {
      name: 'CORE_ALPHA_AMBER_A_40',
      tw: 'alpha-amber-a-40',
      color: 'var(--core-alpha-amber-a-40)',
      theme: 'theme.colors[alpha-amber-a-40]',
    },
  ],
  'Colors Static Mono Color': [
    {
      name: 'COLORS_STATIC_MONO_10',
      tw: 'static-mono-10',
      color: 'rgb(var(--colors-static-mono-10))',
      theme: 'theme.colors[static-mono-10]',
    },
    {
      name: 'COLORS_STATIC_MONO_40',
      tw: 'static-mono-40',
      color: 'rgb(var(--colors-static-mono-40))',
      theme: 'theme.colors[static-mono-40]',
    },
    {
      name: 'COLORS_STATIC_MONO_90',
      tw: 'static-mono-90',
      color: 'rgb(var(--colors-static-mono-90))',
      theme: 'theme.colors[static-mono-90]',
    },
    {
      name: 'COLORS_STATIC_MONO_WHITE',
      tw: 'static-mono-white',
      color: 'rgb(var(--colors-static-mono-white))',
      theme: 'theme.colors[static-mono-white]',
    },
    {
      name: 'COLORS_STATIC_MONO_BLACK',
      tw: 'static-mono-black',
      color: 'rgb(var(--colors-static-mono-black))',
      theme: 'theme.colors[static-mono-black]',
    },
  ],
  'Colors Static Transparent Color': [
    {
      name: 'COLORS_STATIC_TRANSPARENT_BLACK_05',
      tw: 'static-transparent-black-05',
      color: 'var(--colors-static-transparent-black-05)',
      theme: 'theme.colors[static-transparent-black-05]',
    },
    {
      name: 'COLORS_STATIC_TRANSPARENT_BLACK_10',
      tw: 'static-transparent-black-10',
      color: 'var(--colors-static-transparent-black-10)',
      theme: 'theme.colors[static-transparent-black-10]',
    },
    {
      name: 'COLORS_STATIC_TRANSPARENT_BLACK_15',
      tw: 'static-transparent-black-15',
      color: 'var(--colors-static-transparent-black-15)',
      theme: 'theme.colors[static-transparent-black-15]',
    },
    {
      name: 'COLORS_STATIC_TRANSPARENT_BLACK_20',
      tw: 'static-transparent-black-20',
      color: 'var(--colors-static-transparent-black-20)',
      theme: 'theme.colors[static-transparent-black-20]',
    },
    {
      name: 'COLORS_STATIC_TRANSPARENT_BLACK_40',
      tw: 'static-transparent-black-40',
      color: 'var(--colors-static-transparent-black-40)',
      theme: 'theme.colors[static-transparent-black-40]',
    },
    {
      name: 'COLORS_STATIC_TRANSPARENT_BLACK_70',
      tw: 'static-transparent-black-70',
      color: 'var(--colors-static-transparent-black-70)',
      theme: 'theme.colors[static-transparent-black-70]',
    },
    {
      name: 'COLORS_STATIC_TRANSPARENT_WHITE_05',
      tw: 'static-transparent-white-05',
      color: 'var(--colors-static-transparent-white-05)',
      theme: 'theme.colors[static-transparent-white-05]',
    },
    {
      name: 'COLORS_STATIC_TRANSPARENT_WHITE_10',
      tw: 'static-transparent-white-10',
      color: 'var(--colors-static-transparent-white-10)',
      theme: 'theme.colors[static-transparent-white-10]',
    },
    {
      name: 'COLORS_STATIC_TRANSPARENT_WHITE_15',
      tw: 'static-transparent-white-15',
      color: 'var(--colors-static-transparent-white-15)',
      theme: 'theme.colors[static-transparent-white-15]',
    },
    {
      name: 'COLORS_STATIC_TRANSPARENT_WHITE_20',
      tw: 'static-transparent-white-20',
      color: 'var(--colors-static-transparent-white-20)',
      theme: 'theme.colors[static-transparent-white-20]',
    },
    {
      name: 'COLORS_STATIC_TRANSPARENT_WHITE_40',
      tw: 'static-transparent-white-40',
      color: 'var(--colors-static-transparent-white-40)',
      theme: 'theme.colors[static-transparent-white-40]',
    },
    {
      name: 'COLORS_STATIC_TRANSPARENT_WHITE_70',
      tw: 'static-transparent-white-70',
      color: 'var(--colors-static-transparent-white-70)',
      theme: 'theme.colors[static-transparent-white-70]',
    },
  ],
  'Colors Static Point Color': [
    {
      name: 'COLORS_STATIC_POINT_RED',
      tw: 'static-point-red',
      color: 'rgb(var(--colors-static-point-red))',
      theme: 'theme.colors[static-point-red]',
    },
    {
      name: 'COLORS_STATIC_POINT_ORANGE',
      tw: 'static-point-orange',
      color: 'rgb(var(--colors-static-point-orange))',
      theme: 'theme.colors[static-point-orange]',
    },
    {
      name: 'COLORS_STATIC_POINT_YELLOW',
      tw: 'static-point-yellow',
      color: 'rgb(var(--colors-static-point-yellow))',
      theme: 'theme.colors[static-point-yellow]',
    },
    {
      name: 'COLORS_STATIC_POINT_GREEN',
      tw: 'static-point-green',
      color: 'rgb(var(--colors-static-point-green))',
      theme: 'theme.colors[static-point-green]',
    },
    {
      name: 'COLORS_STATIC_POINT_MINT',
      tw: 'static-point-mint',
      color: 'rgb(var(--colors-static-point-mint))',
      theme: 'theme.colors[static-point-mint]',
    },
    {
      name: 'COLORS_STATIC_POINT_BLUE',
      tw: 'static-point-blue',
      color: 'rgb(var(--colors-static-point-blue))',
      theme: 'theme.colors[static-point-blue]',
    },
    {
      name: 'COLORS_STATIC_POINT_VIOLET',
      tw: 'static-point-violet',
      color: 'rgb(var(--colors-static-point-violet))',
      theme: 'theme.colors[static-point-violet]',
    },
    {
      name: 'COLORS_STATIC_POINT_HELIX',
      tw: 'static-point-helix',
      color: 'rgb(var(--colors-static-point-helix))',
      theme: 'theme.colors[static-point-helix]',
    },
  ],
  'Colors Static Etc Color': [
    {
      name: 'COLORS_STATIC_ETC_BG_DA',
      tw: 'static-etc-bg-da',
      color: 'rgb(var(--colors-static-etc-bg-da))',
      theme: 'theme.colors[static-etc-bg-da]',
    },
    {
      name: 'COLORS_STATIC_ETC_BG_HELIX_GIFT',
      tw: 'static-etc-bg-helix-gift',
      color: 'var(--colors-static-etc-bg-helix-gift)',
      theme: 'theme.colors[static-etc-bg-helix-gift]',
    },
    {
      name: 'COLORS_STATIC_ETC_SERIES_DEFAULT',
      tw: 'static-etc-series-default',
      color: 'rgb(var(--colors-static-etc-series-default))',
      theme: 'theme.colors[static-etc-series-default]',
    },
    {
      name: 'COLORS_STATIC_ETC_DIMMED',
      tw: 'static-etc-dimmed',
      color: 'var(--colors-static-etc-dimmed)',
      theme: 'theme.colors[static-etc-dimmed]',
    },
  ],
  'Colors Theme Solid Color': [
    {
      name: 'COLORS_THEME_SOLID_0',
      tw: 'theme-solid-0',
      color: 'rgb(var(--colors-theme-solid-0))',
      theme: 'theme.colors[theme-solid-0]',
    },
    {
      name: 'COLORS_THEME_SOLID_10',
      tw: 'theme-solid-10',
      color: 'rgb(var(--colors-theme-solid-10))',
      theme: 'theme.colors[theme-solid-10]',
    },
    {
      name: 'COLORS_THEME_SOLID_20',
      tw: 'theme-solid-20',
      color: 'rgb(var(--colors-theme-solid-20))',
      theme: 'theme.colors[theme-solid-20]',
    },
    {
      name: 'COLORS_THEME_SOLID_40',
      tw: 'theme-solid-40',
      color: 'rgb(var(--colors-theme-solid-40))',
      theme: 'theme.colors[theme-solid-40]',
    },
    {
      name: 'COLORS_THEME_SOLID_60',
      tw: 'theme-solid-60',
      color: 'rgb(var(--colors-theme-solid-60))',
      theme: 'theme.colors[theme-solid-60]',
    },
    {
      name: 'COLORS_THEME_SOLID_100',
      tw: 'theme-solid-100',
      color: 'rgb(var(--colors-theme-solid-100))',
      theme: 'theme.colors[theme-solid-100]',
    },
  ],
  'Colors Theme Transparent Color': [
    {
      name: 'COLORS_THEME_TRANSPARENT_10',
      tw: 'theme-transparent-10',
      color: 'var(--colors-theme-transparent-10)',
      theme: 'theme.colors[theme-transparent-10]',
    },
    {
      name: 'COLORS_THEME_TRANSPARENT_20',
      tw: 'theme-transparent-20',
      color: 'var(--colors-theme-transparent-20)',
      theme: 'theme.colors[theme-transparent-20]',
    },
    {
      name: 'COLORS_THEME_TRANSPARENT_30',
      tw: 'theme-transparent-30',
      color: 'var(--colors-theme-transparent-30)',
      theme: 'theme.colors[theme-transparent-30]',
    },
    {
      name: 'COLORS_THEME_TRANSPARENT_50',
      tw: 'theme-transparent-50',
      color: 'var(--colors-theme-transparent-50)',
      theme: 'theme.colors[theme-transparent-50]',
    },
  ],
  'Colors Theme BG Color': [
    {
      name: 'COLORS_THEME_BG_BASE',
      tw: 'theme-bg-base',
      color: 'rgb(var(--colors-theme-bg-base))',
      theme: 'theme.colors[theme-bg-base]',
    },
    {
      name: 'COLORS_THEME_BG_BASE_ALT',
      tw: 'theme-bg-base-alt',
      color: 'rgb(var(--colors-theme-bg-base-alt))',
      theme: 'theme.colors[theme-bg-base-alt]',
    },
    {
      name: 'COLORS_THEME_BG_SURFACE',
      tw: 'theme-bg-surface',
      color: 'rgb(var(--colors-theme-bg-surface))',
      theme: 'theme.colors[theme-bg-surface]',
    },
    {
      name: 'COLORS_THEME_BG_SURFACE_ALT',
      tw: 'theme-bg-surface-alt',
      color: 'rgb(var(--colors-theme-bg-surface-alt))',
      theme: 'theme.colors[theme-bg-surface-alt]',
    },
  ],
  'Colors Theme Etc Color': [
    {
      name: 'COLORS_THEME_ETC_BUTTON_PRIMARY',
      tw: 'theme-etc-button-primary',
      color: 'rgb(var(--colors-theme-etc-button-primary))',
      theme: 'theme.colors[theme-etc-button-primary]',
    },
    {
      name: 'COLORS_THEME_ETC_BUTTON_SECONDARY',
      tw: 'theme-etc-button-secondary',
      color: 'rgb(var(--colors-theme-etc-button-secondary))',
      theme: 'theme.colors[theme-etc-button-secondary]',
    },
    {
      name: 'COLORS_THEME_ETC_SKELETON',
      tw: 'theme-etc-skeleton',
      color: 'var(--colors-theme-etc-skeleton)',
      theme: 'theme.colors[theme-etc-skeleton]',
    },
    {
      name: 'COLORS_THEME_ETC_BG_BLUR',
      tw: 'theme-etc-bg-blur',
      color: 'var(--colors-theme-etc-bg-blur)',
      theme: 'theme.colors[theme-etc-bg-blur]',
    },
  ],
  'Colors Viewer Static Color': [
    {
      name: 'COLORS_VIEWER_STATIC_EPUB_WHITE_BG',
      tw: 'viewer-static-epub-white-bg',
      color: 'rgb(var(--colors-viewer-static-epub-white-bg))',
      theme: 'theme.colors[viewer-static-epub-white-bg]',
    },
    {
      name: 'COLORS_VIEWER_STATIC_EPUB_WHITE_TEXT',
      tw: 'viewer-static-epub-white-text',
      color: 'rgb(var(--colors-viewer-static-epub-white-text))',
      theme: 'theme.colors[viewer-static-epub-white-text]',
    },
    {
      name: 'COLORS_VIEWER_STATIC_EPUB_LIGHTGRAY_BG',
      tw: 'viewer-static-epub-lightgray-bg',
      color: 'rgb(var(--colors-viewer-static-epub-lightgray-bg))',
      theme: 'theme.colors[viewer-static-epub-lightgray-bg]',
    },
    {
      name: 'COLORS_VIEWER_STATIC_EPUB_LIGHTGRAY_TEXT',
      tw: 'viewer-static-epub-lightgray-text',
      color: 'rgb(var(--colors-viewer-static-epub-lightgray-text))',
      theme: 'theme.colors[viewer-static-epub-lightgray-text]',
    },
    {
      name: 'COLORS_VIEWER_STATIC_EPUB_SEPIA_BG',
      tw: 'viewer-static-epub-sepia-bg',
      color: 'rgb(var(--colors-viewer-static-epub-sepia-bg))',
      theme: 'theme.colors[viewer-static-epub-sepia-bg]',
    },
    {
      name: 'COLORS_VIEWER_STATIC_EPUB_SEPIA_TEXT',
      tw: 'viewer-static-epub-sepia-text',
      color: 'rgb(var(--colors-viewer-static-epub-sepia-text))',
      theme: 'theme.colors[viewer-static-epub-sepia-text]',
    },
    {
      name: 'COLORS_VIEWER_STATIC_EPUB_DARKGRAY_BG',
      tw: 'viewer-static-epub-darkgray-bg',
      color: 'rgb(var(--colors-viewer-static-epub-darkgray-bg))',
      theme: 'theme.colors[viewer-static-epub-darkgray-bg]',
    },
    {
      name: 'COLORS_VIEWER_STATIC_EPUB_DARKGRAY_TEXT',
      tw: 'viewer-static-epub-darkgray-text',
      color: 'rgb(var(--colors-viewer-static-epub-darkgray-text))',
      theme: 'theme.colors[viewer-static-epub-darkgray-text]',
    },
    {
      name: 'COLORS_VIEWER_STATIC_EPUB_BLACK_BG',
      tw: 'viewer-static-epub-black-bg',
      color: 'rgb(var(--colors-viewer-static-epub-black-bg))',
      theme: 'theme.colors[viewer-static-epub-black-bg]',
    },
    {
      name: 'COLORS_VIEWER_STATIC_EPUB_BLACK_TEXT',
      tw: 'viewer-static-epub-black-text',
      color: 'rgb(var(--colors-viewer-static-epub-black-text))',
      theme: 'theme.colors[viewer-static-epub-black-text]',
    },
    {
      name: 'COLORS_VIEWER_STATIC_EPUB_GREEN_BG',
      tw: 'viewer-static-epub-green-bg',
      color: 'rgb(var(--colors-viewer-static-epub-green-bg))',
      theme: 'theme.colors[viewer-static-epub-green-bg]',
    },
    {
      name: 'COLORS_VIEWER_STATIC_EPUB_GREEN_TEXT',
      tw: 'viewer-static-epub-green-text',
      color: 'rgb(var(--colors-viewer-static-epub-green-text))',
      theme: 'theme.colors[viewer-static-epub-green-text]',
    },
    {
      name: 'COLORS_VIEWER_STATIC_HIGHLIGHT_SELECT',
      tw: 'viewer-static-highlight-select',
      color: 'var(--colors-viewer-static-highlight-select)',
      theme: 'theme.colors[viewer-static-highlight-select]',
    },
    {
      name: 'COLORS_VIEWER_STATIC_HIGHLIGHT_RED',
      tw: 'viewer-static-highlight-red',
      color: 'var(--colors-viewer-static-highlight-red)',
      theme: 'theme.colors[viewer-static-highlight-red]',
    },
    {
      name: 'COLORS_VIEWER_STATIC_HIGHLIGHT_ORANGE',
      tw: 'viewer-static-highlight-orange',
      color: 'var(--colors-viewer-static-highlight-orange)',
      theme: 'theme.colors[viewer-static-highlight-orange]',
    },
    {
      name: 'COLORS_VIEWER_STATIC_HIGHLIGHT_GREEN',
      tw: 'viewer-static-highlight-green',
      color: 'var(--colors-viewer-static-highlight-green)',
      theme: 'theme.colors[viewer-static-highlight-green]',
    },
    {
      name: 'COLORS_VIEWER_STATIC_HIGHLIGHT_MINT',
      tw: 'viewer-static-highlight-mint',
      color: 'var(--colors-viewer-static-highlight-mint)',
      theme: 'theme.colors[viewer-static-highlight-mint]',
    },
    {
      name: 'COLORS_VIEWER_STATIC_HIGHLIGHT_BLUE',
      tw: 'viewer-static-highlight-blue',
      color: 'var(--colors-viewer-static-highlight-blue)',
      theme: 'theme.colors[viewer-static-highlight-blue]',
    },
    {
      name: 'COLORS_VIEWER_STATIC_HIGHLIGHT_BROWN',
      tw: 'viewer-static-highlight-brown',
      color: 'var(--colors-viewer-static-highlight-brown)',
      theme: 'theme.colors[viewer-static-highlight-brown]',
    },
    {
      name: 'COLORS_VIEWER_STATIC_HIGHLIGHT_VIOLET',
      tw: 'viewer-static-highlight-violet',
      color: 'var(--colors-viewer-static-highlight-violet)',
      theme: 'theme.colors[viewer-static-highlight-violet]',
    },
  ],
  'Colors Viewer Theme Color': [
    {
      name: 'COLORS_VIEWER_THEME_BUTTON_LINE',
      tw: 'viewer-theme-button-line',
      color: 'var(--colors-viewer-theme-button-line)',
      theme: 'theme.colors[viewer-theme-button-line]',
    },
    {
      name: 'COLORS_VIEWER_THEME_EPUB_HYPERLINK',
      tw: 'viewer-theme-epub-hyperlink',
      color: 'rgb(var(--colors-viewer-theme-epub-hyperlink))',
      theme: 'theme.colors[viewer-theme-epub-hyperlink]',
    },
    {
      name: 'COLORS_VIEWER_THEME_TTS_HIGHLIGHT',
      tw: 'viewer-theme-tts-highlight',
      color: 'var(--colors-viewer-theme-tts-highlight)',
      theme: 'theme.colors[viewer-theme-tts-highlight]',
    },
  ],
};

exports.colorTheme = {
  ...colorTheme,
  ...newColorTheme,
};
exports.legacyColorTheme = colorTheme;
exports.newColorTheme = newColorTheme;
